export const LogFnExecTime = (logFn?: unknown) => {
    const log = logFn && typeof logFn === 'function' ? logFn : console.log;

    return function (target: any, name: string, descriptor: PropertyDescriptor) {
        const method = descriptor.value;
        descriptor.value = async function (...args) {
            const startTime = Date.now();

            const result = await method.apply(this, args);

            log(`${name}() completed. Elapsed ${Date.now() - startTime}`);

            return result;
        };
    };
};
